import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';;
import { Router } from '@angular/router';
import { ContractThemaNego } from '@core/models/contract-thema-nego.model';
import { BaseService } from '@core/services/base/base.service';
import { ErrorHandlerService, HttpError } from '@core/services/error-handler.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContractThemaNegoService extends BaseService {
  public themaNegotiationRoute = '/contract_thema_nego';

  constructor(
    private httpService: HttpClient,
    private snackBar: MatSnackBar,
    private router: Router,
    private errorHandlerService: ErrorHandlerService
  ) {
    super();
  }

  public getList(filter): Observable<any> {
    const httpErrors: HttpError[] = [
      {
        statusCode: 404,
        message: 'Impossible de récuperer la liste des négociations thématiques. Veuillez essayer plus tard.',
      },
      {
        statusCode: 500,
        message: 'Une erreur est survenue. Veuillez essayer plus tard.',
      },
    ];

    let url = environment.contract_microservice_api_base_url + '/contract_thema_nego?' + this.getParamsFromFilter(filter);

    return new Observable(observer => {
      this.httpService
        .get(url)
        .pipe(
          map(response => {
            let result = [];

            if (response['data']) {
              let guaranteedThemaNegotiationList: ContractThemaNego[] = [];
              let notGuaranteedThemaNegotiationList: ContractThemaNego[] = [];

              response['data'].map(negotiation => {
                if (negotiation.isGuaranteed) {
                  guaranteedThemaNegotiationList.push(new ContractThemaNego(negotiation));
                } else {
                  notGuaranteedThemaNegotiationList.push(new ContractThemaNego(negotiation));
                }
              });

              return [guaranteedThemaNegotiationList, notGuaranteedThemaNegotiationList];
            }

            return result;
          })
        )
        .subscribe(
          (response: any) => observer.next(response),
          (
              error //{
            ) =>
            // this.errorHandlerService.showErrorMessage(httpErrors, error.status);
            // observer.error(error);
            // }
            error =>
              observer.error(this.catchError(error))
        );
    });
  }

  public create(data) {
    const httpErrors: HttpError[] = [
      {
        statusCode: 404,
        message: 'Impossible de sauvegarder la négociation thématique. Veuillez essayer plus tard.',
      },
      {
        statusCode: 500,
        message: 'Une erreur est survenue. Veuillez essayer plus tard.',
      },
    ];

    let url = environment.contract_microservice_api_base_url + this.themaNegotiationRoute;

    if (data.isGuarantee) {
      url += '/guarantee';
    } else {
      url += '/not-guarantee';
    }

    return new Observable(observer => {
      this.httpService.post(url, data).subscribe(
        response => {
          if (response && response['data']) {
            observer.next(new ContractThemaNego(response['data']));
          } else {
            observer.next(response);
          }
        },
        error => observer.error(this.catchError(error))
      );
    });
  }

  public edit(negotiation): Observable<any> {
    const httpErrors: HttpError[] = [
      {
        statusCode: 404,
        message: 'Impossible de mettre à jour la négociation thématique. Veuillez essayer plus tard.',
      },
      {
        statusCode: 500,
        message: 'Une erreur est survenue. Veuillez essayer plus tard.',
      },
    ];

    let url = environment.contract_microservice_api_base_url + this.themaNegotiationRoute;

    if (negotiation.isGuarantee) {
      url += '/guarantee';
    } else {
      url += '/not-guarantee';
    }

    url += '/' + negotiation.id;

    return new Observable(observer => {
      this.httpService.put(url, negotiation).subscribe(
        response => {
          if (response && response['data']) {
            observer.next(new ContractThemaNego(response['data']));
          } else {
            observer.next(response);
          }
        },
        error => observer.error(this.catchError(error))
      );
    });
  }

  public remove(id) {
    let url = environment.contract_microservice_api_base_url + this.themaNegotiationRoute + '/' + id;

    return new Observable(observer => {
      this.httpService.delete(url).subscribe(
        () => {
          observer.next(true);
        },
        error => {
          this.catchError(error);
          observer.error(false);
        }
      );
    });
  }

  public catchError(error: any, routeRedirect: string = null): any {
    this.snackBar.open(error.error?.data?.msg ? error.error?.data?.msg : 'Une erreur est survenue', null, {
      duration: 2000,
      verticalPosition: 'top',
    });

    if (routeRedirect) {
      this.router.navigate([routeRedirect]);
    }

    return error;
  }
}
